import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-9" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex mb-3" }
const _hoisted_5 = { class: "col-md" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center" }, "Carousel images", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["VForm"], { form: $setup.form }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode($setup["VField"], {
                  class: "flex-grow-1",
                  name: "newTitle",
                  "show-error": false
                }),
                _createElementVNode("button", {
                  class: "btn btn-danger mx-2",
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('cancel')), ["prevent"]))
                }, "Cancel"),
                _createVNode($setup["VSubmit"], {
                  color: "success",
                  text: "Save"
                })
              ]),
              _createVNode($setup["VField"], {
                name: "newBody",
                is: "textarea"
              })
            ]),
            _: 1
          }, 8, ["form"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createVNode($setup["ImageUploader"], {
            class: "flex-wrap",
            modelValue: $setup.images,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.images) = $event)),
            reorderable: "reorderable"
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ], 64))
}